import { graphql, useStaticQuery } from "gatsby";

export const useDisclaimerData = () => {
  const { kontentItemDisclaimerGlobal } = useStaticQuery(graphql`
    query {
      kontentItemDisclaimerGlobal {
        elements {
          disclaimer_copy {
            value
            images {
              url
              height
              width
            }
            modular_content {
              ... on kontent_item_linked_image {
                system {
                  type
                  codename
                }
                elements {
                  image {
                    value {
                      url
                      width
                      height
                    }
                  }
                  url {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  return kontentItemDisclaimerGlobal.elements.disclaimer_copy;
};
